import { useRouter } from 'next/router'

const useIsHomePage = () => {
  const router = useRouter()
  const {
    pathname,
    asPath,
    query: { application },
  } = router

  return (
    pathname === '/' ||
    pathname === '/signin' ||
    pathname === '/[application]' ||
    asPath === `/${application}`
  )
}

export default useIsHomePage
